import { useField } from "formik";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import Typography from "@mui/material/Typography";

export default function DRxTextarea(props: any) {
  const { errorText, ...rest } = props;
  const [field, meta] = useField(props);

  return (
    <>
      <TextareaAutosize
        error={meta.touched && meta.error}
        {...field}
        {...rest}
      />
      <Typography
        color="error"
        className="error"
        variant="body2"
        component="div"
      >
        {meta.error}
      </Typography>
    </>
  );
}
